/** RDS-3.2 Manheim light labels, meanings and sources (see LightBadge). */
export const LIGHTS: Record<string, { label: string; tone: string; meaning: string }> = {
  GREEN: {
    label: 'Green',
    tone: 'green',
    meaning: 'Seller guarantee: the lower engine, transmission and rear-end / final drive are arbitrable.',
  },
  YELLOW: {
    label: 'Yellow',
    tone: 'yellow',
    meaning: 'Announcements: the seller announced conditions that limit arbitration.',
  },
  RED: {
    label: 'Red / As-Is',
    tone: 'red',
    meaning: 'As-is: not eligible for arbitration; all other auction rules still apply.',
  },
  NOT_AS_IS: {
    label: 'Not as-is',
    tone: 'none',
    meaning: 'Digital listing that is not as-is but announces no light (not an announced green light).',
  },
};

export const LIGHT_SOURCES: Record<string, string> = {
  REGISTRATION: 'from the lane / Simulcast registration',
  DEBI_AS_IS: "from the listing's as-is flag",
  ANNOUNCEMENT: "from the listing's announcements",
  PRIOR_LANE: "from this VIN's last lane run (history, not this listing)",
};

export function lightLabel(light?: string | null): string {
  const key = (light || '').trim().toUpperCase();
  return LIGHTS[key]?.label ?? '–';
}
